import React, { useRef, useEffect } from "react";
import World from "../../../../assets/svg-maps/world.robinson";
import chroma from "chroma-js";
import countries from "i18n-iso-countries";
import styled from "styled-components";

import { colors, LegendColor } from "../../../../theme";
import Map from "../../../dataviz/DataMap";
import { data, scales } from "./assets/data.json";

countries.registerLocale(require("i18n-iso-countries/langs/fr.json"));

const Container = styled.div`
  margin: 40px 0 60px;

  @media (max-width: 767px) {
    margin: 40px 0 50px;
  }
`;

const Legend = styled.div`
  color: ${colors.textColor};
  margin: 15px auto 0;
  width: 70%;

  @media (max-width: 1023px) {
    width: 85%;
  }

  @media (max-width: 767px) {
    width: 100%;
  }

  h1 {
    color: black;
    font-size: 1.6rem;
    font-weight: 600;
    margin-bottom: 15px;
    text-align: center;
  }

  ul {
    list-style: none;
    margin: 0;
    padding: 0;
  }

  li {
    font-size: 1.3rem;
    line-height: 2.4rem;
  }
`;

const scale = scales.H2_Testing_policy;

function getLocationColor(countryId) {
  const value = data[countryId] && data[countryId].H2_Testing_policy;

  const scaleKey = Object.keys(scale).map((val) => parseInt(val, 10));

  if (!value) {
    return chroma(colors.borderColor).brighten(0.6);
  } else if (value === scaleKey[1]) {
    return chroma(colors.red).darken(0.1);
  } else if (value === scaleKey[2]) {
    return chroma(colors.red).brighten(2);
  } else if (value === scaleKey[3]) {
    return chroma(colors.blue).brighten(0.75);
  }
}

function getTooltipContent(countryId) {
  return {
    title: (
      <>
        <span className={`flag-icon flag-icon-${countryId.toLowerCase()}`} />
        {countries.getName(countryId, "fr")}
      </>
    ),
  };
}

function CovidWorldResponseTestPolicy() {
  const mapRef = useRef(null);

  useEffect(() => {
    Object.keys(data).forEach((countryId) => {
      const el = mapRef.current.querySelector(`path[id="${countryId}"]`);
      if (el) {
        el.style.fill = getLocationColor(countryId);
      }
    });
  }, []);

  return (
    <Container>
      <Map
        map={World}
        containerRef={mapRef}
        getTooltipContent={getTooltipContent}
      />
      <Legend>
        <h1>Politique de test adoptée</h1>
        <ul>
          <li>
            <LegendColor color={chroma(colors.borderColor).brighten(0.6)} /> Non
            référencé
          </li>
          <li>
            <LegendColor color={chroma(colors.red).darken(0.5)} /> {scale[1]}
          </li>
          <li>
            <LegendColor color={chroma(colors.red).brighten(1.8)} /> {scale[2]}
          </li>
          <li>
            <LegendColor color={chroma(colors.blue).brighten(0.95)} />{" "}
            {scale[3]}
          </li>
        </ul>
      </Legend>
    </Container>
  );
}

export default CovidWorldResponseTestPolicy;
